'use strict';

export default class GroupAdminController {
  /*@ngInject*/

  errors = {
    submit: undefined
  };
  saveMessage = '';

  constructor($http, $cookies, Group, Auth, $scope, $timeout, $stateParams, $uibModal ) {
    this.$http = $http;
    this.$cookies = $cookies;
    this.Group = Group;           //inject as a service
    this.Auth = Auth;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$stateParams = $stateParams;
    this.$uibModal = $uibModal;

    //Define the data variables here
    this.user;
    this.editPhysicianForm = {};

    // Analytics data variables
    this.physicians;
    this.patients;
    this.timeouts;
    this.checklists;
    this.allergies;

    this.analytics;

    this.questions;

    this.modelValues = {
      selectedOption: 'User',
      value: ['User', 'Checklist', 'Patient', 'Schedule', 'Allergy', 'Procedure']
    };

    //Datepicker config
    this.timeTo;
    this.timeFrom;

    this.dateOptions = {
      dateDisabled: 'disabled',
      formatYear: 'yy',
      maxDate: new Date(2020, 5, 22),
      minDate: new Date(),
      startingDay: 1
    };

    this.format = 'MM/dd/yyyy';

    this.timeTo = {
      opened: false
    };

    this.timeFrom = {
      opened: false
    }


    this.physicianLimit = 10;
    this.physicianCurrentPage = 1;

    this.timeoutByDateLimit = 10;
    this.timeoutByDateCurrentPage = 1;

    this.individualTimeoutLimit = 10;
    this.individualTimeoutCurrentPage = 1;

    this.userSortLimit = 10;
    this.userSortCurrentPage = 1;

    this.checklistSortLimit = 10;
    this.checklistSortCurrentPage = 1;

    this.patientSortLimit = 10;
    this.patientSortCurrentPage = 1;

    this.scheduleSortLimit = 10;
    this.scheduleSortCurrentPage = 1;

    this.allergySortLimit = 10;
    this.allergySortCurrentPage = 1;

    this.procedureSortLimit = 10;
    this.procedureSortCurrentPage = 1;

    this.patientFeedLimit = 5;
    this.physicianFeedLimit = 5;

  }

  $onInit() {
    let promises = [];
    let group = {};
    this.pdfView = true;
    this.Auth.getCurrentUser()
      .then((user) => {
      this.user = user;         //To set the user details ,group name etc
      //For safestartadmin role users
      if(this.user.role == 'safestartadmin') {
        group._id = this.$stateParams.id;
        this.user.group = group
        this.Group.getGroupDetails(group._id)
          .then((response) => {
            this.user.group = response
          })
      }
    })
      .then(() => {
      let timeoutPromise = this.Group.analytics(this.user, 'Schedule')
      .then(response => {
        this.timeouts = response;
        this.weeklyTimeouts = this.weeklyData(response);
        return response;
      });

      let checklistPromise = this.Group.analytics(this.user, 'Checklist')
      .then(response => {
        this.checklists = response;
        this.weeklyChecklists = this.weeklyData(response);
        return response;
      });

      let allergiesPromise = this.Group.analytics(this.user, 'Allergy')
        .then(response => {
          this.allergies = response
          // this.weeklyAllergies = this.weeklyData(response)
          return response
        })

        let proceduresPromise = this.Group.analytics(this.user, 'Procedure')
          .then(response => {
            this.procedures = response
            // this.weeklyAllergies = this.weeklyData(response)
            return response
          })

      let patientPromise = this.Group.analytics(this.user, 'Patient')
        .then(response => {
          this.patients = response;
          this.weeklyPatients = this.weeklyData(response);
          return response;
        })

      let physicianPromise = this.Group.analytics(this.user, 'User')
      .then(response => {
        this.physicians = response;
        this.weeklyPhysicians = this.weeklyData(response);
        return response;
      });

      let analyticsPromise = this.Group.analytics(this.user, this.modelValues.selectedOption)
        .then(response => {
          this.analytics = response;
          return response;
        });

      let getQuestions = this.Group.getQuestion(this.user.group._id)
        .then(response => {
          this.questions = response.data;
          return response;
        });

      promises.push(timeoutPromise, allergiesPromise, patientPromise, checklistPromise, proceduresPromise, physicianPromise, analyticsPromise, getQuestions);
      return Promise.all(promises)
        .then(() => {
          this.patientFeed = this.patientFeedAnalytics()
        })
        .then(() => {
          this.physicianFeed = this.physicianFeedAnalytics()
        })
        .then(() => {
          return this.analyticsData();
        })
        .then(() => {
          return this.byDate();
        })
        .then(() => {
          /*To bind the code asynchronously*/
          return this.$scope.$applyAsync();
        })
    })
  }

  physicianFeedAnalytics = () => {
    let feed = []
    this.physicians.map((user, key) => {
      if(user.staffRole && user.staffRole !== 'user' ) {
        let createdAt = new Date(user.createdAt);
        feed.push(`The User ${user.firstName} ${user.lastName} with staff role ${user.staffRole} was added on date ${createdAt.toLocaleString()}`);
      }
    })
    return feed;
  }

  patientFeedAnalytics = () => {
    let feed = []
    this.patients.map((patient, key) => {
      let createdAt = new Date(patient.createdAt);
      feed.push(`The Patient ${patient.firstName} ${patient.lastName} was added on ${(createdAt.toLocaleString())}`);
    })
    return feed;
  }

  weeklyData = (data) => {
    // Sort per weekly by date
    let todayDate = new Date();
    let updatedAt;
    let result = [];
    for(let i = 0; i < data.length; i++) {
      updatedAt = new Date(data[i].updatedAt);
      let diff = Math.abs(todayDate.getTime() - updatedAt.getTime()) / (1000 * 60 * 60 * 24.0)
      if(diff <= 7 ) {
        result.push(data[i])
      }
    }
    return result;
  }

  /*Functions which contain data to be shown on initialize*/
  analyticsData = () => {
    //To get the timeout details
    this.completedTimeouts = [];

    /*Set the timeouts related data here*/
    for (let inc = 0; inc < this.timeouts.length; inc++) {
      //For completed timeouts
      if (this.timeouts[inc].state == 'completed') {
        this.completedTimeouts.push(this.timeouts[inc]);
      }
    }
  }

  // New analytics data filter
  filter = (model, timeFrom, timeTo) => {
    return this.Group.analytics(this.user, model, timeFrom, timeTo)
      .then(response => {
        this.analytics = response
      });
  }

  // Open or close the two datepickers
  timeFromPicker = () => {
    this.timeFrom.opened = true
  }

  timeToPicker = () => {
    this.timeTo.opened = true
  }

  clear = () => {
    this.timeTo
  }

  byDate = () => {
    this.dateArray = [];
    let createdAt;


    for (let inc = 0, count = 0; inc < this.timeouts.length; inc++) {
      let dateObject = {};

      createdAt = new Date(this.timeouts[inc].createdAt);
      createdAt.setHours(0,0,0,0);      //Set the hours to 0 here

      if(this.dateArray.length == 0) {
        dateObject.date = createdAt.toDateString().toLocaleString('en-us');   //set the date time string
        dateObject.timeoutsCreated = 1;       //initialize the object
        //Check if the timeout is completed or not
        if(this.timeouts[inc].state == 'completed') {
          dateObject.timeoutsCompleted = 1;    //initialize the object
        }
        else {
          dateObject.timeoutsCompleted = 0;    //initialize the object
        }

        //Push the first Object to the array to initialize
        this.dateArray.push(dateObject);
        count++;                              //increment the count for the json element
      }

      else {
        //Compare with the previous date,if it matches then increment else add new
        if(createdAt.toDateString().toLocaleString('en-us') == this.dateArray[count - 1].date) {
          this.dateArray[count - 1].timeoutsCreated ++ ;
          //Check if the current timeout is completed or not
          if(this.timeouts[inc].state == 'completed') {
            this.dateArray[count - 1].timeoutsCompleted ++ ;
          }
        }
        else {
          dateObject.date = createdAt.toDateString().toLocaleString('en-us');   //set the date time string
          dateObject.timeoutsCreated = 1;       //initialize the new object

          //Check if the timeout is completed or not
          if(this.timeouts[inc].state == 'completed') {
            dateObject.timeoutsCompleted = 1;    //initialize the new object
          }
          else {
            dateObject.timeoutsCompleted = 0;    //initialize the new object
          }
        //Push the changed Object to the array
          this.dateArray.push(dateObject);
          count++;                              //increment the count for the json element
        }
      }
    }
  }
  /*Other operations functions*/
  editPriviledges = (physicianId, physicianRole) => {
    let data = {};
    data._id = physicianId;
    if(physicianRole == 'user') {
      data.role = 'groupadmin';
    } else {
      data.role = 'user';
    }
    // Send the ajax request
    this.Group.setPriviledges(data)
      .then(()=>{
        this.Group.getPhysicians(this.user)
          .then((response)=> {
            this.physicians = response;
          });
      });
  }

  deletePhysician = (physicianId, index) => {
    this.Group.deletePhysicians(physicianId)
      .then((response) => {
        //Update the scope
        this.physicians.splice(index, 1);
      });
  }

  sendPdf = (checklistArray, dateArray) => {
    this.pdfView = false
   this.Group.sendPdf(checklistArray, dateArray, this.user)
     .then((response) => {
       this.pdfView = true;
   })
     .catch((err) => {
      console.log(err)
     })
  };

  changeStatus = (id, status) => {
    this.Group.changeStatus(id, status)
      .then(() => {
        this.Group.getPhysicians(this.user)
          .then((response)=> {
            this.physicians = response;
          });
      });
  }

    openModal = (params, data) => {
    let template;
    if(params == 'inviteUser') {
      template = require('../../../components/user-modification-modal/user-invite-modal.html')
    }
    else if(params == 'editUser') {
      template = require('../../../components/user-modification-modal/user-edit-modal.html')
    }
    else if(params == 'renameGroup') {
      template = require('../../../components/user-modification-modal/group-rename-modal.html')
    }
    else if(params == 'addQuestion') {
      template = require('../../../components/user-modification-modal/create-question-model.html')
    }
      var modalInstance = this.$uibModal.open({
//      animation: true,
      ariaLabelledBy: 'modal-title',
      ariaDescribedBy: 'modal-body',
      template: template,
      controller: 'UserModificationModalController',
      controllerAs: 'vm',
//      size: size,
//      appendTo: parentElem,
      resolve: {
        editUser: () => {
          return data;
        }
      }
    });

    modalInstance.result.then( () => {
      // Call the api after the modal function
      this.Group.getPhysicians(this.user)
        .then((response)=> {
          this.physicians = response;
        })
    }, function () {
      console.log('Modify User Modal dismissed.');
    })
  }

  deleteQuestion = (questionId, index) => {
    this.Group.deleteQuestions(questionId)
      .then((response) => {
        //Update the scope
        this.questions.splice(index, 1);
      });
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/groupAdmin/groupAdmin.controller.js